import createIcon from '../../createIcon';

/**
 * @component @name TipsAndUpdates
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNi4yNSAyMUgxMC4yNUMxMC4yNSAyMi4xIDkuMzUgMjMgOC4yNSAyM0M3LjE1IDIzIDYuMjUgMjIuMSA2LjI1IDIxWk00LjI1IDIwSDEyLjI1VjE4SDQuMjVWMjBaTTE1Ljc1IDEwLjVDMTUuNzUgMTQuMzIgMTMuMDkgMTYuMzYgMTEuOTggMTdINC41MkMzLjQxIDE2LjM2IDAuNzUgMTQuMzIgMC43NSAxMC41QzAuNzUgNi4zNiA0LjExIDMgOC4yNSAzQzEyLjM5IDMgMTUuNzUgNi4zNiAxNS43NSAxMC41Wk0yMC42MiA4LjM3TDE5LjI1IDlMMjAuNjIgOS42M0wyMS4yNSAxMUwyMS44OCA5LjYzTDIzLjI1IDlMMjEuODggOC4zN0wyMS4yNSA3TDIwLjYyIDguMzdaTTE4LjI1IDdMMTkuMTkgNC45NEwyMS4yNSA0TDE5LjE5IDMuMDZMMTguMjUgMUwxNy4zMSAzLjA2TDE1LjI1IDRMMTcuMzEgNC45NEwxOC4yNSA3WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const TipsAndUpdates = createIcon('TipsAndUpdates', [
  [
    'path',
    {
      d: 'M6.25 21H10.25C10.25 22.1 9.35 23 8.25 23C7.15 23 6.25 22.1 6.25 21ZM4.25 20H12.25V18H4.25V20ZM15.75 10.5C15.75 14.32 13.09 16.36 11.98 17H4.52C3.41 16.36 0.75 14.32 0.75 10.5C0.75 6.36 4.11 3 8.25 3C12.39 3 15.75 6.36 15.75 10.5ZM20.62 8.37L19.25 9L20.62 9.63L21.25 11L21.88 9.63L23.25 9L21.88 8.37L21.25 7L20.62 8.37ZM18.25 7L19.19 4.94L21.25 4L19.19 3.06L18.25 1L17.31 3.06L15.25 4L17.31 4.94L18.25 7Z',
      key: '1ot8yj',
    },
  ],
]);

export default TipsAndUpdates;
